export const BREAKPOINTS = {
  PHONE_SMALL: 350,
  PHONE: 600,
  PHONE_BIGGER: 768,
  TABLET_PORTRAIT: 900,
  TABLET_LANDSCAPE: 1200,
  DESKTOP: 1800,
}

export const GUTTER = 20